module.exports = __webpack_public_path__ + "img/earth_clouds_2048.5616c53e.png";